import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { OfbizFormsService, RemoteFormData } from '@urbannex/ofbiz-forms';
import { CustomContainerDirective } from '../../custom-container/custom-container.directive';
import { CustomContainerInterFace } from '../../custom-container/custom-container-interface';

export interface CustomListContainerInterFace {
    responseData:{
      remoteFormData:RemoteFormData;
      queryStringMap:Map<string,string>;
      rows:any[];
      viewIndex:number;
      viewSize:number;
    };

}


@Component({
  selector: 'ubs-custom-list-container',
  templateUrl: './custom-list-container.component.html',
  styleUrls: ['./custom-list-container.component.scss']
})

export class CustomListContainerComponent implements AfterViewInit, OnChanges{
  @Input() remoteFormData:RemoteFormData;
  @Input() renderComponent:any;

  @ViewChild(CustomContainerDirective, {static: false}) customContainerHost!: CustomContainerDirective;
   
  constructor(
    private cdref: ChangeDetectorRef,
    private ofbizFormSerive:OfbizFormsService,) { }
  
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["remoteFormData"] || changes["renderComponent"]){

      this.getList();
      //this.getList(this.remoteFormData);
      /* if(this.customContainerHost){
        console.log(this.customContainerHost);
        if(this.renderComponent){
          this.loadComponent(this.renderComponent);
          this.cdref.detectChanges();
        }
  
      } */
    }
  }
  ngAfterViewInit(): void {
    if(this.customContainerHost){
      console.log(this.customContainerHost);
      if(this.renderComponent){
        if(this.remoteFormData){
          //this.loadComponent(this.renderComponent);
          this.cdref.detectChanges();
        }
      }

    }
  }
  loadComponent(responseData:any,renderComponent:any){
    //const workBenchItem = currentComponent;
    //const componentFactory = this.componentFactoryResolver.resolveComponentFactory(currentComponent);
    //console.log(componentFactory.componentType);
    console.log("ViewContainerRef updated")
    console.log(this.customContainerHost.viewContainerRef);
    const viewContainerRef = this.customContainerHost.viewContainerRef;//this.ngxWorkbench.viewContainerRef;
    //const componentRef = viewContainerRef.createComponent(componentFactory);
    const componentRef = viewContainerRef.createComponent(renderComponent);
    (<CustomListContainerInterFace>componentRef.instance).responseData = responseData;
    //(<CustomContainerInterFace>componentRef.instance).data = currentComponent.data;
    componentRef.changeDetectorRef.detectChanges();
  }
   
   getList():any{
    if (!this.remoteFormData || !this.renderComponent) {
      return;
    }
    let responseData = {
      remoteFormData:this.remoteFormData,
      queryStringMap:new Map<string,string>(),
      rows:[],
      viewIndex:0,
      viewSize:0
    }
    this.ofbizFormSerive.getList(this.remoteFormData)
    .subscribe((response:any) => {
      const statusCode = response["statusCode"];
      switch (statusCode) {
        case 200:
          if(response["successMessage"] == "OK"){
            const data = response["data"];
            const formData = data["formData"];
            if(data["responseMessage"] == "success"){
              console.log({formData:formData});
              responseData["rows"] = formData["rows"];
              responseData["viewIndex"] = formData["viewIndex"];
              responseData["viewSize"] = formData["viewSize"];
              this.loadComponent(responseData,this.renderComponent)            
              
            }
          }
          break;
        case 404:
        
          break;
        case 500:
        
          break;
        default:
          break;
      }
    });

    //remoteFormData = this.addParameters(remoteFormData,this.fieldOptions);
    
    return responseData;
   }

}
